// Copyright (c) Bentley Systems

/**
 * Default color value for iModel element rendering when no explicit color is specified.
 *
 * A green hex color (#50CE67) used as the fallback color for:
 * - New iModel value creation
 * - Color picker initialization in the Enable BECS dialog
 * - BP_DEFAULT_COLOR table entries
 *
 * Hex color code with leading \# symbol (e.g., #RRGGBB)
 *
 * @defaultValue `"#50CE67"`
 * @see SetIntelligentContentDefaultColorDto for backend validation
 * @see EfColorPicker for color selection UI component
 */
export const DEFAULT_COLOR = "#50CE67";
